import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
  HttpErrorResponse
} from '@angular/common/http';
import { BehaviorSubject, EMPTY, Observable, throwError } from 'rxjs';
import { map, catchError, switchMap, filter, take } from 'rxjs/operators';
import { AuthService } from '../auth.service';
import { NavServiceService } from '../services/nav-service.service';
import { checkDomain } from '../Classes/checkDomain';
import { Router } from '@angular/router';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { PermissionService } from '../services/permission.service';


@Injectable()
export class ApiInterceptorInterceptor implements HttpInterceptor {

  static token = "";
  static refresh_token = "";
  constructor(public authService: AuthService, public navService: NavServiceService, public router: Router, private snackBar: MatSnackBar, private permission: PermissionService) { }

  private isRefreshing = false;
  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (request.method === 'POST' || request.method === 'PUT') {
      this.ShiftDates(request.body);
    }

    // request = request.clone({ headers: request.headers.set('Authorization', 'Bearer ' + ApiInterceptorInterceptor.token) });
    // request = request.clone({ headers: request.headers.set('Accept', 'application/json') });
    // request = request.clone({ withCredentials: true });

    let authReq = request;
    const token = localStorage.getItem('access_token');

    if (token != null) {
      authReq = this.addTokenHeader(request, token);
    }

    return next.handle(authReq).pipe(catchError(error => {
      if (error instanceof HttpErrorResponse && !authReq.url.includes('login') && error.status === 401) {
        if (error.error.error != undefined && error.url.split("/").pop() === 'refresh') {
            localStorage.removeItem('access_token');
            ApiInterceptorInterceptor.token = null
            localStorage.removeItem('refresh_token');
            localStorage.removeItem('domain');
            localStorage.removeItem('user');
            localStorage.removeItem('role');
            this.permission.clearPermission();
            ApiInterceptorInterceptor.refresh_token = null;
          return this.router.navigate(['/login'], {replaceUrl : true});
        }
        return this.handle401Error(authReq, next);
      }
      if (error.status === 403){
        // console.log(error);
        let message = error?.error?.message != null && error?.error?.message != "" ? error?.error?.message : "Unauthorized";
        this.snackBar.open(message, 'Close', {
          duration: 10000,
          panelClass: ['snackbar']
        });

        // this.navService.NavigateParentRoute();
      }
      if (error.status === 503){
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
        localStorage.removeItem('user');
        localStorage.removeItem('role');
        this.permission.clearPermission();
        this.router.navigate(['/maintenance'], {replaceUrl : true});
        return EMPTY;
      }
      return throwError(error);
    })) as Observable<HttpEvent<any>>;
  }

  private handle401Error(request: HttpRequest<any>, next: HttpHandler) {
    if (!this.isRefreshing) {
      this.isRefreshing = true;
      this.refreshTokenSubject.next(null);
      const token = localStorage.getItem('refresh_token');

      if (token) {
        return this.authService.refreshToken(token).pipe(
          switchMap((token: any) => {
            this.isRefreshing = false;
            if (token?.error == "invalid_request"){
              localStorage.removeItem('access_token');
              ApiInterceptorInterceptor.token = null
              localStorage.removeItem('refresh_token');
              localStorage.removeItem('domain');
              localStorage.removeItem('user');
              localStorage.removeItem('role');
              this.permission.clearPermission();  
              ApiInterceptorInterceptor.refresh_token = null;
              return this.router.navigate(['/login'], {replaceUrl : true});
            }
            else {
              localStorage.setItem('access_token', token.access_token);
              ApiInterceptorInterceptor.token = token.access_token;
              localStorage.setItem('refresh_token', token.refresh_token);
              localStorage.setItem('domain', checkDomain().toString());
              ApiInterceptorInterceptor.refresh_token = token.refresh_token;
              this.refreshTokenSubject.next(token.access_token);

              return next.handle(this.addTokenHeader(request, token.access_token));
            }
          }),
          catchError((err) => {
            this.isRefreshing = false;
            this.navService.LogOut();
            return throwError(err);
          })
        );
      }
    }
    return this.refreshTokenSubject.pipe(
      filter(token => token !== null),
      take(1),
      switchMap((token) => next.handle(this.addTokenHeader(request, token)))
    );
  }

  private addTokenHeader(request: HttpRequest<any>, token: string) {

    if (token) {
      request = request.clone({ withCredentials: true });
      return request = request.clone({
        setHeaders: {
          'Authorization': `Bearer ${token}`,
          'rejectUnauthorized': 'false',
          'Accept': 'application/json',
        }
      })
    } else {
      return request;
    }
  }

  ShiftDates(body: any) {
    if (body === null || body === undefined) {
      return body;
    }

    if (typeof body !== 'object') {
      return body;
    }

    for (const key of Object.keys(body)) {
      const value = body[key];
      if (value instanceof Date) {
        body[key] = new Date(Date.UTC(value.getFullYear(), value.getMonth(), value.getDate(), value.getHours(), value.getMinutes()
          , value.getSeconds()));
      } else if (typeof value === 'object') {
        this.ShiftDates(value);
      }
    }
  }
}
